import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { LogoutButtonProps } from './types';

const LogoutButton = (props: LogoutButtonProps) => {
  const { logout } = props;

  return (
    <div>
      <Button
        className="h-10 w-full bg-transparent text-sm font-semibold text-[hsl(var(--destructive-soft))] hover:bg-destructive/10 active:bg-destructive/15"
        leftIcon={<LogOut className="size-5" />}
        onClick={logout}
        size="md"
        variant="ghost"
      >
        Выйти
      </Button>
    </div>
  );
};

export default LogoutButton;